import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import '../../assets/css/landing.css'

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Navigation */}
      {/* <nav className="landing-nav">
        <div className="landing-container">
          <div className="nav-content">
            <div className="nav-logo">
              <span className="logo-text">eaquahealth</span>
            </div>
            <div className="nav-links">
              <a href="#features">Features</a>
              <a href="#how-it-works">How It Works</a>
              <a href="#testimonials">Success Stories</a>
              <Link to="/login" className="landing-btn landing-btn-secondary">Login</Link>
              <Link to="/register" className="landing-btn landing-btn-primary">Get Started</Link>
            </div>
          </div>
        </div>
      </nav> */}

      {/* Hero Section */}
      <section className="hero-section">
        {/* Video Background */}
        <div className="hero-video-container">
          <video 
            className="hero-video" 
            autoPlay 
            muted 
            loop 
            playsInline
            // poster="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1920&q=80"
            poster="/hero_vid2.mp4"
          >
            {/* <source src="https://videos.pexels.com/video-files/3129671/3129671-hd_1920_1080_30fps.mp4" type="video/mp4" /> */}
            <source src="/hero_vid2.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="hero-video-overlay"></div>
        </div>
        
        <div className="landing-container">
          <div className="hero-content animate-fade-in">
            <h1>Empowering Africa&apos;s <span style={{ color: 'var(--secondary-dark)' }}>Fish Farming</span> Through Technology</h1>
            <p className="subtitle">
              Monitor water quality, track fish health, get expert veterinary advice, 
              and optimize your aquaculture operations—all in one platform.
            </p>
            <div className="hero-buttons">
              <Link to="/register" className="landing-btn landing-btn-accen landing-btn-lg" style={{backgroundColor:'var(--secondary-teal)'}}>
                Get Started
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </Link>
              <Link to="/demo" className="landing-btn landing-btn-secondary landing-btn-lg">
                Join our Network
              </Link>
            </div>
            {/* <div className="hero-stats">
              <div className="hero-stat">
                <div className="number">500+</div>
                <div className="label">Active Farms</div>
              </div>
              <div className="hero-stat">
                <div className="number">98%</div>
                <div className="label">Disease Prevention</div>
              </div>
              <div className="hero-stat">
                <div className="number">24/7</div>
                <div className="label">Expert Support</div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="landing-section problem-section">
        <div className="landing-container">
          <div className="section-header">
            <h2 style={{color: 'var(--white)'}}>Challenges Fish Farmers Face Daily</h2>
            <p>Traditional aquaculture management is reactive, not proactive. These problems cost farmers time, money, and livelihoods.</p>
          </div>
          <div className="features-grid">
            <div className="problem-card">
              <div className="icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2v20M2 12h20"/>
                  <circle cx="12" cy="12" r="10"/>
                </svg>
              </div>
              <h3>Water Quality Issues</h3>
              <p>Manual testing is time-consuming and often misses critical changes that can lead to fish mortality.</p>
            </div>
            <div className="problem-card">
              <div className="icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <h3>Disease Outbreaks</h3>
              <p>Without early detection, diseases spread rapidly through entire stocks, causing devastating losses.</p>
            </div>
            <div className="problem-card">
              <div className="icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3>Limited Expert Access</h3>
              <p>Finding qualified aquaculture veterinarians when you need them most can be nearly impossible.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section id="features" className="landing-section landing-section-light">
        <div className="landing-container">
          <div className="section-header">
            <h2>Complete Aquaculture Management Platform</h2>
            <p>Everything you need to run a successful, sustainable fish farm—from water monitoring to market access.</p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon feature-icon-blue">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>
                </svg>
              </div>
              <h3>Real-Time Water Monitoring</h3>
              <p>IoT sensors track pH, temperature, dissolved oxygen, and ammonia levels 24/7 with instant alerts when parameters go out of range.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon feature-icon-teal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4.8 2.3A.3.3 0 0 0 5 2h14a.3.3 0 0 1 .3.3v19.4a.3.3 0 0 1-.3.3H5a.3.3 0 0 1-.3-.3V2.3z"/>
                  <path d="M12 8v8"/>
                  <path d="M8 12h8"/>
                </svg>
              </div>
              <h3>Health & Disease Management</h3>
              <p>AI-powered symptom checker, vaccination schedules, and direct access to aquaculture veterinarians for rapid diagnosis and treatment.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon feature-icon-orange">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                  <line x1="8" y1="21" x2="16" y2="21"/>
                  <line x1="12" y1="17" x2="12" y2="21"/>
                </svg>
              </div>
              <h3>Farm Analytics Dashboard</h3>
              <p>Comprehensive insights into feed conversion ratios, growth rates, mortality tracking, and profitability analysis to optimize operations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="landing-section landing-section-gray">
        <div className="landing-container">
          <div className="section-header">
            <h2>How eaquahealth Works</h2>
            <p>Get started in three simple steps and transform your aquaculture operation.</p>
          </div>
          <div className="steps-container">
            <div className="step-item">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4>Set Up Your Digital Farm Profile</h4>
                <p>Create your farm profile with pond details, species, and stocking information. Our system automatically configures monitoring parameters based on your specific setup.</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4>Install Smart Monitoring Equipment</h4>
                <p>Deploy our IoT water quality sensors and connect them to the platform. Installation takes less than 30 minutes per pond with our guided setup process.</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4>Monitor, Alert, and Optimize</h4>
                <p>Receive real-time alerts, track growth metrics, consult with veterinarians, and use AI-driven insights to maximize yield and minimize risks.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section id="testimonials" className="landing-section landing-section-light">
        <div className="landing-container">
          <div className="section-header">
            <h2>Success Stories from Fish Farmers</h2>
            <p>Join hundreds of aquaculture professionals who have transformed their operations with eaquahealth.</p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p className="quote">&quot;Since using eaquahealth, we&apos;ve reduced fish mortality by 40% and increased our harvest yield by 25%. The early disease detection alone has saved us thousands of dollars.&quot;</p>
              <div className="author">
                <div className="testimonial-avatar">
                  <div style={{width: '100%', height: '100%', background: 'linear-gradient(135deg, #0066CC, #00A896)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold'}}>CO</div>
                </div>
                <div className="testimonial-info">
                  <h4>Chidi Okafor</h4>
                  <span>Tilapia Farmer, Anambra State</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <p className="quote">&quot; The veterinary consultation feature is a game-changer. I can send photos and water test results and get expert advice within hours, not days. This has prevented several potential disasters.&quot;</p>
              <div className="author">
                <div className="testimonial-avatar">
                  <div style={{width: '100%', height: '100%', background: 'linear-gradient(135deg, #FF6B35, #FFB830)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold'}}>FN</div>
                </div>
                <div className="testimonial-info">
                  <h4>Fatima Nnamdi</h4>
                  <span>Catfish Farmer, Kano State</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <p className="quote">&quot;The analytics dashboard gives me insights I never had before. I can track feed efficiency, predict harvest times, and plan my production cycles much more effectively.&quot;</p>
              <div className="author">
                <div className="testimonial-avatar">
                  <div style={{width: '100%', height: '100%', background: 'linear-gradient(135deg, #10B981, #3B82F6)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold'}}>EO</div>
                </div>
                <div className="testimonial-info">
                  <h4>Emmanuel Osei</h4>
                  <span>Commercial Fish Farmer, Ghana</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="landing-section cta-section">
        <div className="landing-container">
          <h2>Ready to Transform Your Aquaculture Operation?</h2>
          <p>Join the platform that&apos;s helping fish farmers increase yields, reduce risks, and build sustainable businesses.</p>
          <div className="hero-buttons">
            <Link to="/register" className="landing-btn landing-btn-accent landing-btn-lg">
              Start Your Free Trial
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
            <a href="#contact" className="landing-btn landing-btn-secondary landing-btn-lg">
              Contact Sales
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="landing-container">
          <div className="footer-grid">
            <div className="footer-brand">
              <h3>eaquahealth</h3>
              <p>Empowering fish farmers with smart technology for sustainable aquaculture. Monitor, manage, and optimize your entire operation from one platform.</p>
            </div>
            <div className="footer-links">
              <h4>Product</h4>
              <ul>
                <li><a href="#features">Features</a></li>
                <li><a href="#how-it-works">How It Works</a></li>
                <li><a href="#pricing">Pricing</a></li>
                <li><a href="#demo">Request Demo</a></li>
              </ul>
            </div>
            <div className="footer-links">
              <h4>Company</h4>
              <ul>
                <li><a href="#about">About Us</a></li>
                <li><a href="#careers">Careers</a></li>
                <li><a href="#blog">Blog</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-links">
              <h4>Support</h4>
              <ul>
                <li><a href="#help">Help Center</a></li>
                <li><a href="#docs">Documentation</a></li>
                <li><a href="#api">API Reference</a></li>
                <li><a href="#status">System Status</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 eaquahealth. All rights reserved. | <a href="/privacy" style={{color: 'inherit'}}>Privacy Policy</a> | <a href="/terms" style={{color: 'inherit'}}>Terms of Service</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;